import routeHandler from './routes';
import MODULE_ID from './moduleId';

const module = {
  moduleType: 'Gallery',
  moduleId: MODULE_ID,
  api: 'galleries',
  path: 'galleries',

  routeHandler,
};
export default module;
